export const SectionOurMissionTranslationsUk = {
  'Our mission': 'Наша місія',
  'First mission': ' Полягає в тому, щоб змінити ваше уявлення про свою шафу.',
  'Second mission':
    ' Задовільнити потребу в користуванні та носінні дорогого гардеробу без необхідності купувати його, що однозначно зекономить ваші кошти та не обмежить в приємних емоціях.',
  'Third mission':
    ' Продовжити життєвий цикл одягу, що нестиме значний позитивний вплив на екологію. Ми знаємо, що суспільство почало розглядати більш свідомі та екологічні способи споживання речей. Тому використання вже існуючих нарядів замість купівлі нових посприяє покращенню екології планети.',
  'Unique cyclic model': "Оренда з нашого каталогу",
  'Description first about model':
    "Оберіть сукню чи костюм, розмір і дати оренди. Доступність і вартість відображаються під час бронювання.",
  'Description second about model':
    "Забронювати можна й без акаунта. Після входу ваші бронювання та їхній стан доступні в одному місці.",
};
